// extracted by mini-css-extract-plugin
export var banner = "_9-0";